export default __webpack_public_path__ + "static/media/Car3.30651f79.jpg";